import { createFileRoute } from '@tanstack/react-router'
import WorkRightsSection from 'Work/components/Work/Sections/Rights/WorkRightsSection'

export const Route = createFileRoute('/work/$workId/rights')({
    component: WorkRightsSection,
})
